module.exports = __webpack_public_path__ + "static/media/banner2.32606084.png";